import React from 'react';
import { ColorPicker } from '@atlassian/jira-color-picker/src/ui/edit/index.tsx';
import { asColor } from '@atlassian/jira-issue-epic-color/src/common/utils.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import type { Props, ColorPickerFieldConfig, FieldValue } from './types.tsx';

const ColorPickerField = (props: Props) => {
	const {
		fieldProps: { value, onChange },
	} = props;

	return <ColorPicker value={value} onChange={onChange} showColorName />;
};

export default withFormField({ transformDefaultValue: asColor })<
	ColorPickerFieldConfig,
	FieldValue
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ColorPickerFieldConfig, Color>, any>'.
>(ColorPickerField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateEpicColorField, mutateIssueColorField } from './utils';
